import { RentEntity } from 'backend-entity';

export type RentModelLite = Omit<RentEntity, 'documents' | 'sessions' | 'customer'>;
